/*
 * PanamaJack — Vacía el input de búsqueda del modal al cargar (el modal abre siempre limpio).
 * Extraído de theme.js durante el rebase a Showcase 10.2.0 (iso-funcional).
 * Requiere jQuery (usa la instancia del tema theme.jQuery, con fallback a jQuery global).
 */
(function () {
  var $ = (window.theme && window.theme.jQuery) || window.jQuery;
  if (!$) return;
  $(function () {
    $("#search-modal input[name='q']").val("");
  });
})();
